import React, { createContext, useState } from 'react';

export const FullPlayerContext = createContext();

export const FullPlayerProvider = ({ children }) => {
  const [player, setPlayer] = useState(false);
  return <FullPlayerContext.Provider value={[player, setPlayer]}>{children}</FullPlayerContext.Provider>;
};
